import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  isSelected?: boolean;
  onClick?: () => void;
  children: ReactNode;
  isSecondary?: boolean;
  isDisabled?: boolean;
};

export const Cell = ({ isSelected, isSecondary, isDisabled, onClick, children }: Props) => {
  return (
    <span
      className={twMerge(
        'block flex-1 text-sm leading-9 border-0 rounded-lg cursor-pointer text-center font-semibold hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-white text-gray-900',
        isSelected && 'bg-blue-700 text-white dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-600',
        isSecondary && 'dark:text-gray-300 text-gray-500',
        isDisabled && 'dark:text-gray-600 text-gray-200 cursor-default hover:bg-transparent dark:hover:bg-transparent',
      )}
      onClick={isDisabled ? undefined : onClick}
    >
      {children}
    </span>
  );
};
